import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import {
  Toast, Modal, TextField, FormLayout,
  ButtonGroup,
  InlineStack,
  RadioButton,
} from "@shopify/polaris";

// import NavTabs from "../components/NavTabs";

import { getPayonnerAuthBalances,reqGoogleAnalytics, reqWalletRecharge, reqWithdrawalCancel } from '../../../../api';

import intl from '../../../../i18n/intl'
// import utils from '../../../../utils/utils'

import './index.css'
import utils from '../../../../utils/utils';
import { isNumber } from "recharts/lib/util/DataUtils";
import PayoneerBalancesSelect from '../../../../components/PayoneerBalancesSelect';
import PayoneerBalancesConfirm from '../../../../components/PayoneerBalancesConfirm';
import PayoneerBalancesConnect from '../../../../components/PayoneerBalancesConnect';
import PayoneerBalancesAgain from '../../../../components/PayoneerBalancesAgain';

class WalletClass extends Component {

  state = {
    //弹窗
    showToast: false,  //弹窗显示
    showToastText: '',  //弹窗文字
    showToastIserror: false, //弹窗是否错误
    //充值弹窗
    chargeActive: false,
    //充值金额
    rechargeAmount: "",
    //备注
    Remarks: "",
    //金额提示
    rechargeAmountError: "",
    //支付方式 (1:PayPal 2:stripe,3:payoneer)
    PaymentMethod: 3,
    //钱包金额
    walletMoney: 0.00,
    // 累计充值金额
    totalRecharge: 0.00,
    // 累计使用金额
    totalUseCount: 0.00,
    //点击充值按钮
    AuthButtonDisable: false,
    chargeError: false,
    typeValue:'pn',//默认是payoneer 
    payoneerBalances:[],//payoneer余额
    payoneerSelectOpen: false,//payoneer选择弹窗
    payoneerAmount:'',//payoneer选择金额
    payoneerConfirm:'',//payoneer确认支付数据
    payoneerConfirmOpen: false,//payoneer确认支付弹窗
    payoneerConnectOpen:false,//payoneer连接弹窗
    payoneer_auth:false,//payoneer授权状态
    payoneerAgainOpen:false,//payoneer支付后刷新数据弹窗
  };

  componentDidMount() {
    this.handleChargeActiveChange()
  }
  //提示弹窗
  toggleToast = (showToastText, showToastIserror = false) => {
    this.setState(({ showToast }) => ({
      showToast: !showToast,
      showToastText: showToastText,
      showToastIserror: showToastIserror
    }));
  };


  // 发送谷歌分析数据
  handleTrackGoogleManager = (sign, data) => {
    try {
      window.gtag('event', sign, data);
    } catch (e) {
      console.log(e)
    }
  }
  // let seoExpertsWindow;//新窗口的window对象
   openWin = (url) => {
    var name;                           //网页名称，可为空;
    var iWidth = 500;                         //弹出窗口的宽度;
    var iHeight = 570;                        //弹出窗口的高度;
    //window.screen.height获得屏幕的高，window.screen.width获得屏幕的宽
    var iTop = (window.screen.height - 30 - iHeight) / 2;       //获得窗口的垂直位置;
    var iLeft = (window.screen.width - 10 - iWidth) / 2;        //获得窗口的水平位置;
    // const newTab = window.open('', '_blank',name, 'height=' + iHeight + ',innerHeight=' + iHeight + ',width=' + iWidth + ',innerWidth=' + iWidth + ',top=' + iTop + ',left=' + iLeft + ',toolbar=no,menubar=no,scrollbars=auto,resizable=no,location=no,status=no');
    // newTab.location = url;
    setTimeout(() => {
      window.open(url, name, 'height=' + iHeight + ',innerHeight=' + iHeight + ',width=' + iWidth + ',innerWidth=' + iWidth + ',top=' + iTop + ',left=' + iLeft + ',toolbar=no,menubar=no,scrollbars=auto,resizable=no,location=no,status=no');
    }, 0);
  }
  //点击充值
  handlechargeAuth = async () => {
    //判断金额小于10 就不进入了
    if (Number(this.state.rechargeAmount) < 10) {
      this.setState({
        rechargeAmountError: "Min 10USD"
      });
      return false;
    }
    this.setState({
      AuthButtonDisable: true
    });
    let text = 'PayPal';
    if (this.state.typeValue === 'pal') {
      text = 'PayPal'
    }
    if (this.state.typeValue === 'dsm') {
      text = 'Stripe'
    }
    if (this.state.typeValue === 'pn') {
      text = 'Payoneer'
    }
    // 谷歌分析函数
    this.handleTrackGoogleManager('Dropshipman pay charge', {
      'domain': utils.getStore('S_SHOP_DOMAIN') || window.S_SHOP_DOMAIN,
      'value': Number(this.state.rechargeAmount),
      'method': text
    });
    if (this.state.typeValue === 'pn' && this.state.payoneer_auth === false) {
     this.handlePayoneerOff()
      return
    }
    if (this.state.typeValue === 'pn' && this.state.payoneer_auth === true) {
      this.handlePayoneerBalances()
      return
    }

    //类型 1 PayPal 2 Stripe
    const params = {
      type: this.state.PaymentMethod,
      money: Number(this.state.rechargeAmount)
    };
    const responseData = await reqWalletRecharge(params);

    if (responseData.code === "200") {
      //类型 1 PayPal 2 Stripe
      if (this.props.setSyncOpen) {
        this.props.setSyncOpen(true)
      }
      if (this.state.PaymentMethod === 1) {
        // window.location.href = responseData.data.url;
        this.openWin(responseData.data.url)
      } else {
        // window.location.href = responseData.data.url;
        this.openWin(responseData.data.url)
      }
      this.callChargeActiveClosed();
      // this.toggleToast(responseData.msg, false);
    } else {

      this.setState({
        AuthButtonDisable: false
      });
      this.toggleToast(responseData.msg);
    }
  };

  // payoneer未授权
  handlePayoneerOff = ()=>{
    this.setState({
      payoneerConnectOpen: true,
      // payoneer_auth: false,
      AuthButtonDisable: false,
      rechargeAmount:'',
      chargeActive: false,
      Remarks: '',
    })
    this.props.setWalletOpen(false)
  }
  // checkbox change
  handleCheckboxChange = (value, id) => {
    this.setState({
      [id]: value

    }, () => {
      // 更新设置
      if (!this.state.saveDataLoading) {
        this.saveData();
      } else {
        setTimeout(() => {
          this.saveData();
        }, 800);
      }
    });
  }

  // input change
  handleInputChange = (field, value) => {
    let values = Number(value)

      this.setState({
        rechargeAmountError: ""
      });
    if (isNumber(values) && values > 0) {
      this.setState({
        [field]: Math.floor(value * 100) / 100,
        payoneerAmount: Math.floor(value * 100) / 100
      });
    } else {
      this.setState({
        [field]: ''
      });
    }
  }

  handleInputAddressChange = (field, value) => {
    this.setState({
      [field]: value
    });
  }

  // 充值弹窗 关闭充值弹窗
  handleChargeActiveChange = () => {
    //Wallet页面Charge按钮点击gtag
    reqGoogleAnalytics('click', 'wallet_charge_click');

    // 谷歌分析函数
    this.handleTrackGoogleManager('Dropshipman charge', { 'domain': utils.getStore('S_SHOP_DOMAIN') || window.S_SHOP_DOMAIN });
    this.setState({
      chargeActive: true,
    });
  };

  // 关闭关闭弹窗
  callChargeActiveClosed = () => {
    this.props.setWalletOpen(false)
    this.setState({
      chargeActive: false,
      rechargeAmount: '',
      payoneerAmount:'',
      rechargeAmountError: "",
      typeValue:'pn',
      PaymentMethod: 3,
      AuthButtonDisable:false,
    });
  };


  callChargeErrorClosed = () => {
    this.setState({
      chargeError: false,
    });
  }

  callSuccessClosed = () => {
    this.setState({
      WithSuccessButton: false,
    });
  }

  //支付方式
  handleFirstButtonClick = (value) => {
    this.setState({
      PaymentMethod: value
    });
  }

  // 关闭确认取消弹窗
  callConfirmActiveClosed = () => {
    this.setState({
      ConfirmActive: false,
    });

    this.setState({
      Confirm_Id: ""
    });

  };

  //提现取消按钮 提交数据
  handleConfirm = async () => {

    if (!isNumber(this.state.Confirm_Id)) {
      this.toggleToast("Submit failed", false);
      return false;
    }

    this.setState({ WithCancelButtonDisable: true })

    await reqWithdrawalCancel({
      'confirm_id': this.state.Confirm_Id,
    }).then(results => {

      this.setState({ WithCancelButtonDisable: false });

      if (results.code === 200) {

        this.setState({ ConfirmActive: false });

        this.toggleToast("Successfully canceled");

        this.getUserSettingsData()
      } else {
        this.toggleToast(results.msg);
        return false;
      }

    })

  }

  handleRadioChange = (_, newValue) => {
    //单选按钮点击事件
    switch (newValue) {
      case "dsm":
        this.setState({
          typeValue: "dsm",
          PaymentMethod:2,
        });
        break;
      case "pal":
        this.setState({
          typeValue: "pal",
          PaymentMethod:1,
        });
        break;
      case "pn":
        this.setState({
          typeValue: "pn",
          PaymentMethod:3,
        });
        break;
      default:
        break;
    }
  };
  // 获取授权账户余额
  handlePayoneerBalances = async ()=>{
    let res = await getPayonnerAuthBalances({money:Number(this.state.rechargeAmount)})
    if (res.code === '200') {
      this.props.setWalletOpen(false)
      this.setState({
        chargeActive:false,
        rechargeAmount:'',
        WithAmount:'',
        payoneerBalances:res.data,
        payoneerSelectOpen:true
      })
    }else {
      this.toggleToast(res.msg)
    }
    this.setState({
      AuthButtonDisable: false,
    });
  }
  // 关闭选择支付账户
  handlePayoneerSelect = ()=>{
    this.setState({
      payoneerSelectOpen:false
    })
  }
  // 获取确认支付数据
  handlePayoneerConfirm = (data)=>{
    this.setState({
      payoneerConfirm:data,
      payoneerConfirmOpen:true
    })
  }
  // 关闭确认支付弹窗
  callPayoneerConfirmClosed = ()=>{
    this.setState({
      payoneerConfirmOpen:false
    })
  }
  callPayoneerConfirmClosed2 = ()=>{
    this.setState({
      payoneerAgainOpen:true
    })
  }
  // 关闭确认授权弹窗
  callPayoneerConnectClosed = ()=>{
    this.setState({
      payoneerConnectOpen:false
    })
  }

  // 刷新数据
  callPayoneerAgainClosed = ()=>{
    this.getUserSettingsData()
    this.setState({
      payoneerAgainOpen:false
    })
  }

  
  render () {
    const toastMarkup = this.state.showToast ? <Toast content={this.state.showToastText} onDismiss={() => this.toggleToast('')} error={this.state.showToastIserror} /> : null;

    const {
      typeValue
    } = this.state;


    // const pageContent = (<span className='fulfillment_top_up' onClick={() => this.handleChargeActiveChange()}>{intl.get("Top Up")}</span>)

    
    const disconnectModal = (
      <Modal
        open={this.state.chargeActive}
        onClose={this.callChargeActiveClosed}
        title={intl.get("Top Up Dropshipman Credits")}
        primaryAction={{
          content: intl.get("Pay"),
          onAction: this.handlechargeAuth,
          loading: this.state.AuthButtonDisable
        }}
        footer={<InlineStack wrap={false}>
          <img style={{marginRight:8}} width={20} src="/sub/points_icon.png" alt="Dropshipman" /> 
          <span>You'll receive <strong> {Number(this.state.rechargeAmount).toFixed(0)} points </strong> once your recharge is complete. </span>
          </InlineStack>
        }
      >
        <Modal.Section>
           
            <FormLayout>
              <TextField
                label={intl.get("Amount") + '(USD)'}
                onChange={this.handleInputChange.bind(this, 'rechargeAmount')}
                value={String(this.state.rechargeAmount)}
                placeholder='10.00'
                type={'number'}
                prefix={'$'}
                error={this.state.rechargeAmountError}
              />
            </FormLayout>
            <div style={{ marginTop: '10px' }}>
              <div className="Polaris-Labelled__LabelWrapper"><div className="Polaris-Label"><label id="PolarisTextField1Label" htmlFor="PolarisTextField1" className="Polaris-Label__Text">{intl.get("Payment account")}</label></div></div>
              <ButtonGroup segmented>
              <div className='balance_recharge_wallet_button'>
              <div
                className={`${
                  typeValue === "pn"
                    ? "dsm_container_border dsm_container"
                    : "dsm_container"
                } `}
              >
                <RadioButton
                  label={
                    <div className="pay_radioLabel">
                      <div>
                        <img src="/payoneer/pay_icon.png" alt="dropshipman" />
                      </div>
                      <div style={{ fontWeight: "bold" }}>{intl.get("Payoneer")}</div>
                    </div>
                  }
                  id="pn"
                  name="pn_pay"
                  checked={typeValue === "pn"}
                  onChange={this.handleRadioChange}
                />
              </div>
              <div
                className={`${
                  typeValue === "pal"
                    ? "dsm_container_border dsm_container"
                    : "dsm_container"
                } `}
              >
                <RadioButton
                  label={
                    <div className="dsm_radioLabel">
                      <div>
                        <img src="/pay_pal.png" alt="dropshipman" />
                      </div>
                      <div>
                        <div style={{ fontWeight: "bold" }}>
                        {intl.get("PayPal")}
                        </div>
                      </div>
                    </div>
                  }
                  id="pal"
                  name="pal_pay"
                  checked={typeValue === "pal"}
                  onChange={this.handleRadioChange}
                />
              </div>
              <div
                className={`${
                  typeValue === "dsm"
                    ? "dsm_container_border dsm_container"
                    : "dsm_container"
                } `}
              >
                <RadioButton
                  label={
                    <div className="dsm_radioLabel">
                      <div>
                        <img src="/dsm_pay.png" alt="dropshipman" />
                      </div>
                      <div>
                        <div style={{ fontWeight: "bold" }}>
                        {intl.get("Stripe")}
                        </div>
                      </div>
                    </div>
                  }
                  id="dsm"
                  name="dsm_pay"
                  checked={typeValue === "dsm"}
                  onChange={this.handleRadioChange}
                />
              </div>
              </div>
                {/* <Button pressed={this.state.PaymentMethod === 1 ? true : false} onClick={() => this.handleFirstButtonClick(1)}>
                  {intl.get("PayPal")}
                </Button>
                <Button pressed={this.state.PaymentMethod === 2 ? true : false} onClick={() => this.handleFirstButtonClick(2)}>
                  {intl.get("Stripe")}
                </Button> */}
              </ButtonGroup>
              
            </div>
           
        </Modal.Section>
      </Modal>
    )

    const ConfirmModel = (
      <Modal
        open={this.state.ConfirmActive}
        onClose={this.callConfirmActiveClosed}
        title={intl.get("Cancel withdraw")}
        primaryAction={{
          content: intl.get('Yes'),
          onAction: this.handleConfirm,
          loading: this.state.WithCancelButtonDisable
        }}
        secondaryActions={[
          {
            content: intl.get('No'),
            onAction: this.callConfirmActiveClosed,
          },
        ]}
      >
        <Modal.Section>
            <span style={{ fontSize: "16px", color: "#202223" }}>{intl.get("Are you sure to cancel the withdraw?")}</span>
        </Modal.Section>
      </Modal>
    )


    const errorModel = (
      <Modal
        open={this.state.chargeError}
        onClose={this.callChargeErrorClosed}
        title={intl.get("Insufficient balance")}
        primaryAction={{
          content: intl.get("OK"),
          onAction: this.callChargeErrorClosed,
        }}
      >

        <Modal.Section>
          <span style={{ fontSize: "16px", color: "#202223" }}>{intl.get("Insufficient balance,withdraw is not supported!")}</span>
        </Modal.Section>

      </Modal>

    )


    const SubmitModel = (
      <Modal
        open={this.state.WithSuccessButton}
        onClose={this.callSuccessClosed}
        title={intl.get("Submit successfully")}
        primaryAction={{
          content: intl.get("OK"),
          onAction: this.callSuccessClosed,
        }}
      >

        <Modal.Section>
          <span style={{ fontSize: "16px", color: "#202223" }}>{intl.get("We will review uniformly on Tuesday, U.S.time. As the review is passed, the withdraw is completed.")}</span>
        </Modal.Section>

      </Modal>

    )
    return (

      <div className="">
          {/* {pageContent} */}

          {toastMarkup}
          {/* 充值弹窗 */}
          {disconnectModal}

          {/*取消提现弹窗*/}
          {ConfirmModel}

          {/* 选择payoneer支付账户 */}
          <PayoneerBalancesSelect 
          open={this.state.payoneerSelectOpen} 
          num={this.state.payoneerAmount} 
          data={this.state.payoneerBalances} 
          handlePayoneerSelect={this.handlePayoneerSelect}
          handlePayoneerConfirm={this.handlePayoneerConfirm}
          />
          {/* 确认付款 */}
          <PayoneerBalancesConfirm 
          open={this.state.payoneerConfirmOpen} 
          data={this.state.payoneerConfirm}
          callPayoneerConfirmClosed={this.callPayoneerConfirmClosed}
          callPayoneerConfirmClosed2={this.callPayoneerConfirmClosed2}
          />
          {/* payoneer未授权 */}
          <PayoneerBalancesConnect 
          open={this.state.payoneerConnectOpen} 
          callPayoneerConnectClosed={this.callPayoneerConnectClosed}
          />
          <PayoneerBalancesAgain 
          open={this.state.payoneerAgainOpen} 
          callPayoneerAgainClosed={this.callPayoneerAgainClosed}
          />
          {errorModel}
          {SubmitModel}
      </div>
    );

  }

}
export default withRouter(WalletClass);